<template>
	<div class="modal-chapting">
		<slot name="title"></slot>
		<el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10}"
		 placeholder="Description of the story" v-model.trim="textarea" maxlength="150" show-word-limit>
		</el-input>
		<el-row class="ok-btn">
			<el-button type="primary" @click="closeModal" round>OK</el-button>
		</el-row>
	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations} from 'vuex'
	export default {
		computed: {
			textarea: {
				get() {
					return this.$store.state.bookItem.modalData.editDescription		
				},
				set(value) {
					this.$store.commit('bookItem/updateDescription',value)
				}
			},
			modalData(){
				return this.$store.state.bookItem.modalData
			},
			baseInfo() {
				return this.$store.state.bookItem.baseInfo
			}
		} ,
		methods: {
			closeModal() {
				if (this.modalData.modalType === 'editChaptingDescription') {
					// 修改章节信息
					this.postAxios('/h5/saveWriterChapter', {
						book_id: this.modalData.chapter.book_id,
						chapter_number: this.modalData.chapter.chapter_number,
						title: this.modalData.chapter.title,
						description: this.modalData.editDescription
					}).then((data) => {
							if (data.code === 200) {
								this.$store.commit('bookItem/editChapterFn',{
									chapter_number: this.modalData.chapter.chapter_number,
									description: this.modalData.editDescription
								})
							}
						}, (err) => {
						  // handle authorization error
					});
				}
				if (this.modalData.modalType === 'addChapting') {
					this.postAxios('/h5/createWriterChapter', {
						book_id: this.baseInfo.id,
						chapter_number: (this.baseInfo.total_chapter_count + 1),
						title: `Chapter${this.baseInfo.total_chapter_count + 1}`,
						description: this.modalData.editDescription
					}).then((data) => {
							if (data.code === 200) {
								this.$store.commit('bookItem/addChapterFn',{chapter:data.data,book_id:this.baseInfo.id})
							}
						}, (err) => {
						  // handle authorization error
					});
				}
				this.$store.dispatch('bookItem/okCloseModal')
			}
		}
	}
</script>

<style lang="scss">
	.modal-chapting {
		h2 {
			font-size: 16px;
			color: #6f6f6f;
			padding-bottom: 12px;
		}
		.el-textarea {
			.el-textarea__inner {
				background-color: #f5f5f5;
				color: #909090;
				font-size: 10px;
				letter-spacing: 0.025em;
				font-family: "Sofia Pro Medium";
			}
				
			.el-input__count {
				background-color: #f5f5f5;
			}
		}
	}
</style>
